import { Reducer } from 'redux';
import { EstadoCidadeState, EstadoCidadeTypes } from './types';

const INITIAL_STATE: EstadoCidadeState = {
  data: [],
  error: false,
  loading: false,
  estado: [],
  estadoSelecionado: undefined,
  cidadeSelecionada: undefined,
  nomeSelecionado: undefined,
  nomeParcSelecionado: undefined,
  cnpjSelecionado: undefined,
  cnpjAutoCompSelecionado: undefined,
};

const reducer: Reducer<EstadoCidadeState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EstadoCidadeTypes.LOAD_ESTADO_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EstadoCidadeTypes.LOAD_ESTADO_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        estado: action.payload.estado,
      };
    case EstadoCidadeTypes.LOAD_ESTADO_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        estado: [],
      };
    case EstadoCidadeTypes.LOAD_CIDADE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EstadoCidadeTypes.LOAD_CIDADE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case EstadoCidadeTypes.LOAD_CIDADE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case EstadoCidadeTypes.CITY_SELECT:
      return {
        ...state,
        cidadeSelecionada: action.payload.cidadeSelecionada,
      };
    case EstadoCidadeTypes.STATE_SELECT:
      return {
        ...state,
        estadoSelecionado: action.payload.estadoSelecionado,
      };
    case EstadoCidadeTypes.NAME_SELECT:
      return {
        ...state,
        nomeSelecionado: action.payload.nomeSelecionado,
      };
    case EstadoCidadeTypes.NAME_PARC_SELECT:
      return {
        ...state,
        nomeParcSelecionado: action.payload.nomeParcSelecionado,
      };
    case EstadoCidadeTypes.CNPJ_SELECT:
      return {
        ...state,
        cnpjSelecionado: action.payload.cnpjSelecionado,
      };
    case EstadoCidadeTypes.CNPJ_AUTO_COMP:
      return {
        ...state,
        cnpjAutoCompSelecionado: action.payload.cnpjAutoCompSelecionado,
      };
    case EstadoCidadeTypes.CLEAN:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
